import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import EarthDay from "./pages/EarthDay";
import BackgroundSong from "./BackgroundSong";

const App = () => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/earth" element={<EarthDay />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <BackgroundSong />
    </BrowserRouter>
  );
};

export default App;
